export default __webpack_public_path__ + "static/media/rentals.4925972b.csv";